import { render } from "./HelpVideoButton.vue?vue&type=template&id=b5fd081e"
import script from "./HelpVideoButton.vue?vue&type=script&lang=js"
export * from "./HelpVideoButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/HelpVideoButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5fd081e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5fd081e', __exports__)) {
    console.log('reload')
    api.reload('b5fd081e', __exports__)
  }
  
  module.hot.accept("./HelpVideoButton.vue?vue&type=template&id=b5fd081e", () => {
    console.log('re-render')
    api.rerender('b5fd081e', render)
  })

}


export default __exports__